import React from 'react'
import { GrInstagram } from "react-icons/gr";
import { RxDiscordLogo } from "react-icons/rx";
import { RiTwitterXLine } from "react-icons/ri";

function Footer() {
  return (
    <div className='flex justify-center items-center mt-10 px-4' id='Portfolio'>
      <div className="flex flex-col sm:flex-row items-center justify-between border-t border-[#C0392B] py-4 w-full max-w-5xl text-white">
        <p className='text-lg mt-5 sm:mt-0'>@2024 .All Rights Reserved</p>
        <a href='https://www.instagram.com/luminax_t/'><p className='text-lg mt-5 sm:mt-0'>Created By LuminaX</p></a>
        <div className='text-xl mt-5 sm:mt-0 text-white flex items-center justify-center space-x-5'>
            <a href="https://www.instagram.com/ksy_edit/"><GrInstagram  className='text-white text-2xl hover:text-[#C0392B]'/></a>
            <a href=""><RxDiscordLogo className='text-white text-2xl hover:text-[#C0392B]' /></a>
            <a href="https://x.com/ksy_thumbnails"><RiTwitterXLine className='text-white text-2xl hover:text-[#C0392B]' /></a>
        </div>
      </div>
    </div>
  )
}
export default Footer
